import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { MemberProvider } from "./context/MemberProvider";

import { PortalUserSearchProvider } from "./context/PortalUserSearchContext";
import { AdminUserSearchProvider } from "./context/AdminUserSearchContext";

import { QueryClientProvider, QueryClient } from "react-query";
import App from "./components/Common/App/App";
// import { ReactQueryDevtools } from 'react-query/devtools';
import { disableReactDevTools } from "@fvilers/disable-react-devtools";

if (process.env.NODE_ENV === "production") {
	disableReactDevTools();
}

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<BrowserRouter>
				<AdminUserSearchProvider>
					<PortalUserSearchProvider>
						<AuthProvider>
							<MemberProvider>
									<Routes>
										<Route path="/*" element={<App />} />
									</Routes>
							</MemberProvider>
						</AuthProvider>
					</PortalUserSearchProvider>
				</AdminUserSearchProvider>
			</BrowserRouter>
			{/* <ReactQueryDevtools initialIsOpen={false} /> */}
		</QueryClientProvider>
	</React.StrictMode>
);
